import { useEffect } from "react";
import { useParams, useLocation } from "wouter";
import { apiGet } from "@/lib/api";
import { trackDemoConfirmed } from "@/lib/metrics";

export default function DemoConfirm() {
  const { token } = useParams<{ token: string }>();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!token) { setLocation("/"); return; }
    apiGet<{ redirect?: string }>(`/auth/demo/confirm/${token}`)
      .then(res => { trackDemoConfirmed(); setLocation(res?.redirect || "/app"); })
      .catch(() => setLocation("/"));
  }, [token]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-5">
        <img src="/images/finproject-logo.png" alt="FinProject" className="w-16 h-16 object-contain animate-pulse" />
        <div className="text-center">
          <p className="text-slate-800 text-base font-semibold mb-1">Setting up your workspace…</p>
          <p className="text-slate-500 text-sm">This takes just a moment. Please wait.</p>
        </div>
        <div className="flex gap-1.5 mt-1">
          <span className="w-2 h-2 rounded-full bg-blue-500 animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="w-2 h-2 rounded-full bg-blue-400 animate-bounce" style={{ animationDelay: "150ms" }} />
          <span className="w-2 h-2 rounded-full bg-blue-300 animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      </div>
    </div>
  );
}
